import {Component,Inject,OnInit} from '@angular/core';
import {Tolerance} from '@domain/typecharge/tolerance';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {FacturesToleranceService} from '../factures-tolerance.service';
import {first} from 'rxjs/operators';
import {Result,TypeCodeErreur} from '@domain/common/http/result';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

/**
 * Popin de modification d'une tolérance
 *
 * @author Stéphane Chan Tack
 * @date 09/07/2025
 */
@Component({
    host: {'data-test-id': 'modify-tolerances-popin'},
    templateUrl: './modify-tolerances-popin.component.html'
})
export class ModifyTolerancesPopinComponent implements OnInit {
    /** Tolérance à modifier */
    tolerance: Tolerance;

    /** Pourcentage de tolérance (pour l'affichage) */
    tolerancePourcentage: number;

    /**
     * Constructeur
     *
     * @param data Données en entrée de la popin
     * @param dialogRef Référence à la popin
     * @param toleranceService Service de gestion des tolérances
     * @param toastrService Service de notification
     * @param translateService Service de traduction
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { tolerance: Tolerance },
        private dialogRef: MatDialogRef<ModifyTolerancesPopinComponent>,
        private toleranceService: FacturesToleranceService,
        private toastrService: ToastrService,
        private translateService: TranslateService
    ) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Récupération de la tolérance en entrée de la popin
        this.tolerance = Object.assign({}, this.data.tolerance);

        //Conversion du pourcentage pour l'affichage
        if (this.tolerance.tolerance !== null && this.tolerance.tolerance !== undefined) {
            this.tolerancePourcentage = this.tolerance.tolerance * 100;
        }
    }

    /**
     * Sauvegarde de la tolérance
     */
    onSave(): void {
        //Affecter la nouvelle valeur du pourcentage de tolérance
        this.tolerance.tolerance = !!this.tolerancePourcentage ? this.tolerancePourcentage : 0;

        //Appel au service pour mettre à jour la tolérance
        this.toleranceService.saveTolerance(this.tolerance).pipe(first()).subscribe((result: Result) => {
            //Si la réponse contient un code d'erreur, affichage d'un message d'erreur
            if (result.codeErreur !== TypeCodeErreur.NO_ERROR) {
                //Affichage d'un message d'erreur quand l'enregistrement de la tolérance en base n'a pas fonctionné correctement
                TypeCodeErreur.showError(result.codeErreur, this.translateService, this.toastrService);
            } else {
                //Affichage d'un message de succès si l'enregistrement de la tolérance en base s'est passé correctement
                this.toastrService.success(this.translateService.instant('global.success.enregistrement'));
                //Fermeture de l'écran
                this.dialogRef.close({refresh: true});
            }
        });
    }

    /**
     * Ferme la popin sans sauvegarder
     */
    closeDialog(): void {
        //Fermeture de l'écran sans rafraichissement
        this.dialogRef.close({refresh: false});
    }
}